module.exports = __webpack_public_path__ + "img/transparencia.c77ed10a.png";